/**
 * Right-panel tab order for Pattern of Life.
 * Sentinel tiles, MUI <Tabs>, and TabPanels must all use this list.
 */
export const POL_TAB_IDS = [
  'entities',
  'activity',
  'patterns',
  'correlations',
  'anomalies',
  'outlier_rankings',
  'forecast',
  'routes',
  'dwells',
  'digital',
] as const;

export type POLTabId = (typeof POL_TAB_IDS)[number];

export function polTabIndex(id: POLTabId): number {
  return POL_TAB_IDS.indexOf(id);
}

/** Numeric indexes derived from POL_TAB_IDS (for TabPanel). */
export const POL_TAB = {
  ENTITIES: polTabIndex('entities'),
  ACTIVITY: polTabIndex('activity'),
  PATTERNS: polTabIndex('patterns'),
  CORRELATIONS: polTabIndex('correlations'),
  ANOMALIES: polTabIndex('anomalies'),
  OUTLIER_RANKINGS: polTabIndex('outlier_rankings'),
  FORECAST: polTabIndex('forecast'),
  ROUTES: polTabIndex('routes'),
  DWELLS: polTabIndex('dwells'),
  DIGITAL: polTabIndex('digital'),
} as const;

export type POLTabIndex = (typeof POL_TAB)[keyof typeof POL_TAB];
